import FetchFactory from '@repository/factory';
import Routes from '@repository/routes.client';
import type {
    LoginPayload,
    LoginResponse,
    LogoutResponse,
    ResendEmailResponse,
    RegistrationPayload,
    RegistrationResponse,
    ResetPasswordPayload,
    ResetPasswordResponse,
    RequestResetPasswordResponse,
    ValidateRequestTokenResponse,
} from '@repository/types';

// todo consider/apply composition
class AuthModule extends FetchFactory {
    private readonly RESOURCE = Routes.Auth;
    login(payload: LoginPayload) {
        return this.call<LoginResponse>({
            url: `${this.RESOURCE.login()}`,
            method: 'POST',
            body: payload,
        });
    }

    register(payload: RegistrationPayload) {
        return this.call<RegistrationResponse>({
            url: `${this.RESOURCE.register()}`,
            method: 'POST',
            body: payload,
        });
    }

    logout() {
        return this.call<LogoutResponse>({
            url: `${this.RESOURCE.logout()}`,
            method: 'POST',
        });
    }

    resendEmail(id: string) {
        return this.call<ResendEmailResponse>({
            url: `${this.RESOURCE.resendEmail()}`,
            method: 'POST',
            fetchOptions: {
                query: { id },
            },
        });
    }

    requestResetPassword(email: string) {
        return this.call<RequestResetPasswordResponse>({
            url: `${this.RESOURCE.resetPassword()}`,
            method: 'POST',
            body: { email },
        });
    }

    validateRequestResetPasswordToken(token: string) {
        return this.call<ValidateRequestTokenResponse>({
            url: `${this.RESOURCE.resetPasswordToken(token)}`,
            method: 'GET',
        });
    }

    resetPassword(payload: ResetPasswordPayload, token: string) {
        return this.call<ResetPasswordResponse>({
            url: `${this.RESOURCE.resetPasswordToken(token)}`,
            method: 'POST',
            body: payload,
        });
    }
}

export default AuthModule;
